<template>
    <div>
        <div class="form-group col-12">
            <label for="name">Name</label>
            <input
                id="name"
                v-model="starProduct.name"
                type="text"
                class="form-control"
                :class="{
                    'is-invalid': hasError('name')
                }"
                dir="auto"
                placeholder="Name"
            />

            <div class="invalid-feedback">
                {{ getError('name') }}
            </div>
        </div>

        <div class="form-group col-12">
            <label for="description">Description</label>
            <textarea
                id="description"
                v-model="starProduct.description"
                type="text"
                class="form-control rtl"
                :class="{
                    'is-invalid': hasError('description')
                }"
                dir="auto"
                rows="4"
                placeholder="Description"
            />

            <div class="invalid-feedback">
                {{ getError('description') }}
            </div>
        </div>

        <div class="form-group col-12">
            <label for="stars">Stars</label>
            <input
                id="stars"
                v-model="starProduct.stars"
                type="number"
                min="1"
                class="form-control"
                :class="{
                    'is-invalid': hasError('stars')
                }"
            />

            <div class="invalid-feedback">
                {{ getError('stars') }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            required: false,
            default: () => ({})
        },
        editMode: {
            type: Boolean,
            required: false,
            default: false
        },
        validation: {
            type: Object,
            required: true
        },
        serverErrors: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            starProduct: {}
        };
    },

    watch: {
        starProduct() {
            this.$emit('input', this.starProduct);
        }
    },

    created() {
        this.starProduct = { ...this.value };
    },

    methods: {
        hasError(key) {
            return (
                this.validation.starProduct[key].$error ||
                this.serverErrors.find(error => error.param === key)
            );
        },

        getError(key) {
            return this.$getValidationErrorMessageHandler.handle(
                this.validation.starProduct,
                this.serverErrors,
                key
            );
        }
    }
};
</script>
